import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdministracionCarteraApiService } from '../../services/administracion-cartera-api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BatchExecution } from '../../models/batch';
import { AlertService } from 'src/app/components/_alert/alert.service';

@Component({
    selector: 'app-exec-detail-modal',
    templateUrl: './exec-detail-modal.component.html',
    styleUrls: ['./exec-detail-modal.component.scss']
})
export class ExecDetailModalComponent {

    public processId = '';
    public correctExecutions = 0;
    public errorExecutions = 0;
    public successFiles: string[] = [];
    public errorFiles: string[] = [];

    public isLoading = false;

    constructor(
        public dialogRef: MatDialogRef<ExecDetailModalComponent>,
        private _apiService: AdministracionCarteraApiService,
        private _alertsService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: { id: string, configId: string },
    ) {
        this.getDetail(data.id, data.configId);
    }

    getDetail(id: string, configId: string) {
        this.isLoading = true;
        this._apiService.getExecutionDetail(id, configId).subscribe({
            next: (res) => {
                this.processId = res.id;

                this.correctExecutions = res.amountOfSucessBatchLines;
                this.errorExecutions = res.amountOfBatchLinesWithError;

                this.successFiles = res?.result?.successSignedUrls || [];
                this.errorFiles = res?.result?.errorSignedUrls || [];

                this.isLoading = false;
            },
            error: () => {
                this._alertsService.error('Ocurrió un error al intentar obtener los detalles de la ejecución.');
                this.isLoading = false;
            }
        });
    }
}

